import {makeStyles} from "@material-ui/core";

export const DigitalContractCardStyles = makeStyles(() => ({
    vediButton: {
        marginRight: "1em"
    },
    chipStyle: {
        backgroundColor: "#4fc0e8",
        color: "white"
    },
    containerPadding: {
        padding: "1em",
        height: "100%",
        minHeight: "10.5em",
        overflow: "auto"
    }
}))